<div class="bg-white">
  <div class="border-[bottom p-4">
    <h3 class="pt-2">
      {{ 'Sellers.Products.AddAccount' | translate }}
    </h3>
  </div>
  <app-bank-fields></app-bank-fields>
  <div class="px-3">
    <app-base-report [hasDateRangeFilter]="false"
                     [filterFields]="filterField"
                     [hasCheckboxes]="false"
                     [reportName]="reportName"
                     [defaultColumns]="Columns"
                     [columnsDisplayNames]="displayTableColumns"
                     [data]="bankAccountReportData"
                     [rowsLength]="totalNumberOfRecords"
                     (filterTrigger)="filter($event)"
                     (paginationChange)="paginate($event)"
                     (searchChange)="searchChance($event)"
                     [tableLoading]="loading"
                     [rowActions]="rowActions"
                     (rowActionClicked)="onRowAction($event)"
                     [hasSort]="true"
                     (sortTrigger)="sortChange($event)"
                     [serviceInstance]="listBankAccounts"></app-base-report>
  </div>
</div>
